import { NumberFormat } from '@billy/design-system'

import { getCurrentLocale } from './getCurrentLocale'

export const formatSignedPercentage = (value: number): string => {
  const formatted = NumberFormat.getFormattedNumber(value, getCurrentLocale(), {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    signDisplay: 'exceptZero',
  })

  return `${formatted}%`
}
